import * as React from "react";
import * as staticImages from "../../constants/static-images";
import styled from "styled-components";

interface SubsidiesReceivedInfoBlockProps {}

const SubsidiesReceivedInfoBlock = (props: SubsidiesReceivedInfoBlockProps) => {
  return (
    <SubsidiesReceivedInfoBlockWrapper>
      <div className="container text-justify">
        <p>
          Działanie 8.2 Wspieranie wdrażania elektronicznego biznesu typu B2B
        </p>
        <p>
          Mamy przyjemność poinformować, iż Fakturomania Spółka z ograniczoną odpowiedzialnością realizuje projekt w ramach 8. Osi Priorytetowej
          Społeczeństwo informacyjne – zwiększanie innowacyjności gospodarki Działanie 8.2 Wspieranie wdrażania elektronicznego biznesu typu B2B pn.
          „Usprawnianie procesów finansowo-księgowych i zmniejszanie ich kosztów w firmach dzięki wdrożeniu internetowego systemu klasy B2B”.
        </p>
        <p>
          Niniejszy projekt polegać będzie na wytworzeniu oraz wdrożeniu innowacyjnego Systemu B2B działającego w modelu SaaS (Software as a Service),
          na którym oparta będzie współpraca Wnioskodawcy z partnerami biznesowymi.
          Współpraca ta uwarunkowana jest wytworzeniem i wdrożeniem niniejszego systemu.
          System ten znacząco automatyzować będzie procesy finansowo-księgowe w przedsiębiorstwach współpracujących,
          co stanowić będzie jeden z bodźców do nawiązania współpracy z Wnioskodawcą opartej o planowany do wytworzenia System B2B.
          Dodatkowo System w sposób znaczący usprawni Wnioskodawcy procesy związane z pozyskiwaniem nowych partnerów biznesowych
          bez zaangażowania nadmiernych zasobów (automatyzacja działań marketingowych) oraz bardzo usprawni wszelkie procesy związane z
          podjętą współpracą z partnerami (np. poprzez integrację z przelewy24.pl, PayU, automatyczne wystawianie faktur).
        </p>
        <p>
          Projekt zakłada utworzenie przedsięwzięcia biznesowego prowadzonego w formie elektronicznej B2B,
          czyli automatyzację procesów między wnioskodawcą a partnerami biznesowymi poprzez informatyzację powiązań,
          które powstaną w wyniku realizacji projektu. Ma to w założeniu doprowadzić do zacieśnienia przyszłej współpracy oraz wzrostu
          konkurencyjności poprzez wdrożenie innowacji, zwiększenie efektywności wymiany danych, usprawnienie procesów oraz do zwiększenia przychodów
          zarówno wnioskodawcy jak i jej partnerów biznesowych.
        </p>
        <p>
          Kwota dofinansowania: 47 040 PLN
        </p>
      </div>
      <ImageContainer>
        <img src={staticImages.DOTACJE_POIG_IMAGE} alt="fakturomania dotacje"/>
      </ImageContainer>
    </SubsidiesReceivedInfoBlockWrapper>
  )
};

/** STYLES */

const SubsidiesReceivedInfoBlockWrapper = styled.div`
  color: #424242 !important;
  margin-top: 60px;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export default SubsidiesReceivedInfoBlock


// WEBPACK FOOTER //
// ./src/layouts/subsidies-received-info-block/subsidies-received-info-block.tsx